import {Box, LinearProgress} from "@mui/material";
import * as React from "react";
import {LayoutAtom} from "../providers/layout/LayoutProvider";
import {useRecoilValue} from "recoil";

type ProgressProps = {
   inline?: boolean
}

export const Progress = ({inline}: ProgressProps) => {
   const globalLayout = useRecoilValue(LayoutAtom)

   const sx = inline ? {} : {position: 'relative', left: '25%', top: "0px", width: '50%'}
   return <Box sx={sx}>
      <LinearProgress sx={{
         height: '2px',
         backgroundColor: globalLayout.widgets?.selectionColor || '#808080',
         '& .MuiLinearProgress-bar': {
            backgroundColor: globalLayout.text?.textColor || globalLayout.widgets?.selectionTextColor || '#f0f0f0'
         }
      }}/>
   </Box>
}